import { render, staticRenderFns } from "./Part1DescribeImage.vue?vue&type=template&id=5d5f5baa&scoped=true"
import script from "./Part1DescribeImage.vue?vue&type=script&lang=js"
export * from "./Part1DescribeImage.vue?vue&type=script&lang=js"
import style0 from "./Part1DescribeImage.vue?vue&type=style&index=0&id=5d5f5baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f5baa",
  null
  
)

export default component.exports